<template>
   <div class="div17 cutbox" :style="`background:url(${info.image}) no-repeat;background-size: 100% 100%;`">


      <div class="center-block">
         <div class="text1" data-id="主标题1" data-range="5,8">
            {{ info.titles[0] }}
         </div>
         <div class="text2" data-id="副标题1" data-range="9,12">
            {{ info.titles[1] }}
         </div>
      </div>
   </div>
</template>
<script>
export default {
   name: 'TUWEN017',
   props: {
      info: Object
   },
}
</script>
